/**
 * Strict ordered palette used for every Recharts series in the season-scoped
 * insights feature. No color outside this palette (or the Gold_Design_System
 * tokens) may appear in any chart introduced by this spec.
 *
 * See design.md §10 and Requirements 6.7, 8.12, 18.3, 18.4, 18.5.
 */
export const CHART_PALETTE = [
  '#3d2f0b', // deep gold
  '#876a1e', // warm gold
  '#a48b3c', // muted gold
  '#c7a865', // soft gold
  '#d9c27a', // pale gold
] as const;

/** Dashed-grid stroke color (border-gold-100 equivalent). */
export const CHART_GRID_COLOR = '#e9dcae';

/** Axis tick label color (text-gold-500 equivalent — muted gold). */
export const CHART_AXIS_TICK_COLOR = '#a48b3c';

/** Card-border color used on tooltips and chart containers. */
export const CHART_BORDER_COLOR = '#e9dcae';

/**
 * Axis tick style shared across all charts. Uses Inter (`font-sans`) at
 * `text-[10px]` with the portal's small-caps letter-spacing convention so
 * axis labels match the rest of the admin UI.
 */
export const CHART_AXIS_TICK_STYLE = {
  fill: CHART_AXIS_TICK_COLOR,
  fontSize: 10,
  fontFamily: 'Inter, sans-serif',
  letterSpacing: '0.1em',
  textTransform: 'uppercase' as const,
};
